import { EthereumNetwork } from "../graphql.js"
import { BitcoinNetworkNames, BlockchainNetwork } from "../constants.js"
import { getEvmV2Network } from "../blockchains/evmV2Networks.js"

export const getBlockchainFromNetwork = (network: string) => {
    // Before the v1 list below: it has bsc and matic too, as Ethereum networks
    const evmNetwork = getEvmV2Network(network)
    if (evmNetwork) return evmNetwork.blockchain
    if (Object.values(EthereumNetwork).includes(network as EthereumNetwork)) {
        return BlockchainNetwork.ethereum
    }
    if (Object.keys(BitcoinNetworkNames).includes(network)) {
        return BlockchainNetwork.bitcoin
    }

    return network as BlockchainNetwork
}

// Blockchain code or network name → the network name the app uses for address
// stats, the blockchain select and moneyflow.network ("eth" → "ethereum",
// "arb" → "arbitrum", "btc" → "bitcoin"); anything else is returned as is.
export const getNetworkName = (networkOrBlockchain: string) => {
    const evmNetwork = getEvmV2Network(networkOrBlockchain)
    if (evmNetwork) return evmNetwork.network
    if (networkOrBlockchain === BlockchainNetwork.bitcoin) return 'bitcoin'
    return networkOrBlockchain
}
